export function uploadFileAttachment(attachment) {
  uploadFile(attachment.file, setProgress, setAttributes, handleErrors);

  function setProgress(progress) {
    attachment.setUploadProgress(progress);
  }

  function setAttributes(attributes) {
    attachment.setAttributes(attributes);
  }

}

function handleErrors(data) {
  let bFileError = document.getElementById("b-s-file-error");
  const responseText = data.responseText;
  bFileError.innerHTML = responseText;
  bFileError.classList.remove("hidden");

  const filename = getFilenameFromString(responseText);
  deleteFiguresByFilename(filename);
}

function successCallback(url) {
  return url;
}

export function uploadFile(file) {
  return new Promise((resolve, reject) => {
    var formData = createFormData(file);
    const csrfToken = document
      .querySelector("meta[name='csrf-token']")
      .getAttribute("content");

    const xhr = new XMLHttpRequest();
    xhr.open("POST", "/s/file", true);
    xhr.setRequestHeader("X-CSRF-Token", csrfToken);

    xhr.addEventListener("load", function (event) {
      event.preventDefault();
      if (xhr.status === 201) {
        const url = xhr.responseText;
        resolve(url);
      } else {
        document.getElementById("b-s-file-error").classList.remove("hidden");
        handleErrors(xhr);
        reject(new Error("File upload failed"));
      }
    });

    xhr.addEventListener("error", function (event) {
      reject(new Error("Network error occurred during file upload"));
    });

    xhr.send(formData);
  });
}

function deleteFiguresByFilename(filename) {
  const figures = document.querySelectorAll("figure[data-trix-attachment]");
  let deletedCount = 0;

  figures.forEach((figure) => {
    const attachmentData = figure.getAttribute("data-trix-attachment");
    if (attachmentData) {
      try {
        const attachment = JSON.parse(attachmentData);
        if (attachment.filename === filename) {
          figure.remove();
          deletedCount++;
        }
      } catch (e) {
        console.error("Error parsing attachment data:", e);
      }
    }
  });

  return deletedCount;
}

function getFilenameFromString(str) {
  const match = str.match(/File:\s*(.+)$/);
  return match ? match[1].trim() : null;
}

export function removeFileAttachment(url) {
  const xhr = new XMLHttpRequest();
  const formData = new FormData();
  formData.append("key", url);

  const csrfToken = document
    .querySelector("meta[name='csrf-token']")
    .getAttribute("content");

  xhr.open("DELETE", "/s/file", true);
  xhr.setRequestHeader("X-CSRF-Token", csrfToken);
  xhr.send(formData);
}

export function createFormData(file) {
  var data = new FormData();
  //data.append("key", key);
  data.append("Content-Type", file.type);
  data.append("file", file);
  return data;
}
